import {inject, bindable, customElement} from 'aurelia-framework';
import Backend from "../../backend";
import {RMetaPixel} from "../../util/r-meta-pixel";
import {RGTag} from "../../util/r-gtag";

@customElement('sub-product-item-component')
@inject(Element, Backend)
export class SubProductItemComponent {
  element;
  backend;
  shoppingCart;
  router;
  i18N;

  @bindable product;
  @bindable imgClasses = '';

  productForModal;

  @bindable showEveryTime = false;
  @bindable showQuantity = true;
  @bindable showBuyButton = false;
  @bindable showFeaturedBanner = true;
  @bindable showProductDetailsInModal = true;

  constructor(element, backend) {
    this.element = element;
    this.backend = backend;
  }

  everyTimeChanged() {
    this.element.dispatchEvent(new CustomEvent('every-time-changed', {
      detail: {},
      bubbles: true
    }));
  }

  quantityChanged(event) {
    // The old event has the same name as the one we're about to raise, so it will bubble up and hit our parents' listeners.
    // We do not want duplicates, so the old event needs to be stopped.
    event.stopPropagation()
    this.element.dispatchEvent(new CustomEvent('quantity-changed', {
      detail: {
        productId: this.product.productId,
        productArticleNumber: this.product.articleNumber,
        productName: this.product.name,
        priceIncVat: this.product.priceIncVat,
        quantityIncrement: event.detail.increment,
      },
      bubbles: true
    }));
  }

  buy() {
    this.element.dispatchEvent(new CustomEvent('buy', {
      detail: {
        // Not sure who is using product field directly. Ideally we'd refactor away from it.
        // But event name is not easy to search for. Which should also be fixed by refactoring...
        product: this.product,
        productId: this.product.productId,
        productArticleNumber: this.product.articleNumber,
        productName: this.product.name,
        priceIncVat: this.product.priceIncVat
      },
      bubbles: true
    }));
  }

  showProductDetails(product) {
    // Meta pixel
    const productArticleNumber = this.product.articleNumber;
    RMetaPixel.trackViewContent_product(productArticleNumber);
    RGTag.trackViewItem(productArticleNumber, this.product.name);

    // Modal
    this.productForModal = null;
    this.backend.ProductDetailsQueryHandler_handle({productIdOrSeoKey: product.productId})
      .then(result => this.productForModal = result)
      .then(result => this.modal.open());
  }
}
